import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import Modal from './Modal';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';

function GenericModal({ onClose, containerClass, title, message, saveMessage, modalId, titleClass }) {
  const handleClose = () => {
    onClose();
  };
  return (
    <Modal onClose={handleClose} id={modalId}>
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <div className={titleClass}>
            <ModalHeader
              title={title}
              onClose={handleClose}
            />
          </div>
          <div
            id="modalBody"
            className="modal-body"
            style={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            <div className="container-fluid">
              <div className="row">
                <div className={`col-12 ${containerClass}`}>
                  <div>{message}</div>
                </div>
              </div>
            </div>
          </div>
          <ModalFooter
            onSave={handleClose}
            saveText={saveMessage}
          />
        </div>
      </div>
    </Modal>
  );
}

GenericModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  containerClass: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  saveMessage: PropTypes.string,
  modalId: PropTypes.string.isRequired,
  titleClass: PropTypes.string,
};
GenericModal.defaultProps = {
  containerClass: '',
  title: '',
  message: '',
  saveMessage: '',
  titleClass: '',
};

export default translate(GenericModal);
